import type { InsightsOverviewResponse } from "@nlc/shared-types";

import { formatMetric } from "../formatMetric";
import { Card } from "./Card";

const INTERACTIONS: Array<{
  key: keyof InsightsOverviewResponse["interactions"];
  label: string;
  opacity: number;
}> = [
  { key: "likes", label: "Likes", opacity: 1 },
  { key: "comments", label: "Comments", opacity: 0.7 },
  { key: "shares", label: "Shares", opacity: 0.45 },
  { key: "saved", label: "Saves", opacity: 0.25 },
];

export function InteractionsBreakdown({
  className,
  interactions,
}: {
  className?: string;
  interactions: InsightsOverviewResponse["interactions"];
}) {
  const total = INTERACTIONS.reduce(
    (sum, { key }) => sum + interactions[key],
    0,
  );

  return (
    <Card className={className} title="What people did">
      <p className="-mt-md text-sm text-text-tertiary">
        How people interacted with your posts.
      </p>
      {total > 0 ? (
        <>
          <div className="flex h-2 overflow-hidden rounded-full bg-bg-tertiary">
            {INTERACTIONS.map(({ key, opacity }) => (
              <div
                className="h-full bg-fg-brand-primary"
                key={key}
                style={{
                  opacity,
                  width: `${(interactions[key] / total) * 100}%`,
                }}
              />
            ))}
          </div>
          <ul className="flex flex-col gap-md">
            {INTERACTIONS.map(({ key, label, opacity }) => (
              <li
                className="flex items-center justify-between gap-md text-sm"
                key={key}
              >
                <span className="flex items-center gap-sm font-medium text-text-secondary">
                  <span
                    className="size-2 rounded-xs bg-fg-brand-primary"
                    style={{ opacity }}
                  />
                  {label}
                </span>
                <span className="text-text-tertiary">
                  <span className="font-semibold text-text-primary">
                    {formatMetric(interactions[key])}
                  </span>{" "}
                  · {Math.round((interactions[key] / total) * 100)}%
                </span>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p className="text-sm text-text-tertiary">No interactions yet.</p>
      )}
    </Card>
  );
}
